import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { Token } from '../manager/token';
import { Router } from '@angular/router';
// import { map } from 'rxjs/operators';
// import { Observable } from 'rxjs';
// import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  TokenCls

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router)
  }

  ChangePassword(formbody): any {
    return this.http.post(environment.ApiUrl + '/api/change-password', formbody);
  }

  ResetPasswrd(formbody):any {
    return this.http.post(environment.ApiUrl + '/api/Password_Reset', formbody);
  }
}
